import { render, staticRenderFns } from "./info-bidders.vue?vue&type=template&id=6efbca8c&"
import script from "./info-bidders.vue?vue&type=script&lang=js&"
export * from "./info-bidders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports